export enum PspTypes
{
    MOLLIE = "Mollie",
    RABOBANK = "Rabobank",
    STRIPE = "Stripe",
    NONE = "undefined"
}